<template>


  <div :class="cengji == 0?'procard_wrapCss0 procard_wrap1':'procard_wrapCss0'">
   
    <div class="procard_wrap">
     
    <div class="procard_content" v-if="cengji==0">
      <div class="content_left" v-scroll-animate="'fly-in-left5'">
        <div class="block">
          <el-carousel class="imgLeft" height="31rem" indicator-position="outside" :interval="3000" :autoplay="true" hover-stop> 
            <el-carousel-item v-for="(item,index) in imgArr" :key="index" >
               <a :href="'NscDetail?artId=' +item.articleId+'&lunboObj=lunboObj&typeObj=' +activeIndex" target="_blank"> 
                 <img :src="urlBase+item.image"  class="fade-in" :style="{ width: 'auto', height: '31rem !important', objectFit: 'cover' }" />
               </a>
               <!-- <img :src="urlBase+item.image" @click="gocengji1(item,'lunboObj')" class="fade-in" :style="{ width: 'auto', height: '31rem !important', objectFit: 'cover' }" /> -->
              
               <div class="custom-indicator">
                
                <span class="explainsTxt">{{ item.title }} </span>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="content_right" v-scroll-animate="'fly-in-right5'">
        <div class="right_tit right_tit1">
         
          <span :class="activeindex0== index?'active':''" v-for="(item,index) in listArr" :key="index" @click="changeTab1(index)">
            {{ item.name }}
          </span>
          <a class="moreA" @click="goMore">
            <i class="el-icon-right"></i>
          </a>
          
        
        </div>
        <div class="right_txt" >
         <div  v-for="(item,index) in rightList0" :key="index">


           <a :href="'NscDetail?artId=' +item.id+'&lunboObj=&typeObj=' +activeIndex" target="_blank"> 
              <div :class="(index == 1)?'divtxt divtxt1':'divtxt'" >
                <span class="titleSpan"  v-if="item.title.length>25"><a>{{ item.title.substring(0,25) }}... </a></span>
                <span class="titleSpan" v-else><a>{{ item.title }}</a> </span>
                <span class="timeSpan">  {{ item.publishDate.substring(0,10) }}</span>
              </div>
              </a>
               
            </div>
        </div>
        
      </div>
 
   
    </div>
    
    <div   v-if="visibleStr" v-show="this.itemNow.id != '7' && this.cengji==0" class="xinfang" > 
        <ul >
          <li>
            <h3> 信访举报</h3>
          </li>
          <li>
            <img src="../../assets/w/nsc/3.png"/> 来信请寄：河南省郑州市经济技术开发区航海东路1511号驻中豫港务集团纪检监察组
          </li>
          <!-- <li>
            <img src="../../assets/w/nsc/4.png"/> 来访请到：河南省郑州市经济技术开发区航海东路1511号中豫港务集团来访接待室
          </li> -->
          <li>
            <img src="../../assets/w/nsc/2.png"/> 举报电话：0371-65995558
          </li>
        </ul>
 
    </div>


<!--    
   <div style="width: 90vw;margin:0 auto;">
     <NewsList  />

   </div>
      -->
     
     

     <!-- 纪检监委二级页面 -->
      <!-- 二级菜单切换 -->
      <div class="mainbody0" v-if="cengji == 1">
        <div class="mainbody menus" v-scroll-animate="'slide-itemgk'">
          <a href="/home"><i class="el-icon-s-home"></i></a> / <a @click="gocengji0">党建纪检</a> / {{nowTab}}  
        </div>
        <el-row class="mainbody" >
          <el-col :span="3" :xs="24">
            <div v-scroll-animate="'fly-in-left5gy'" v-for="(item,index) in listArr" :key="index" :class="(activeIndex == index)? 'Lmenu active':'Lmenu'" >
              <a class="jianbian jianbianRed" @click="changeTab(index)">{{item.name}}</a>
            </div>
          </el-col>
          <el-col :span="21" :xs="24">
            <div class="Rcontent">
              <ul>
                <li v-for="(item,index) in rightList" :key="index" v-scroll-animate="'fly-in-right5gy'">
                
                  <div class="Rtitle"> 
                      <a :href="'NscDetail?artId=' +item.id+'&lunboObj=&typeObj=' +activeIndex" target="_blank"> 
                    <!-- <a @click="gocengji1(item)"> -->
                      {{item.title}}</a>
                   <!-- <span style="float: right;">{{item.publishDate.substring(0,10)}}</span> -->
                  </div>
                </li>
              <div class="change_page" >
                <!-- 首页按钮 -->
                <el-button 
                  class="pagination-btn first-last"
                  :disabled="currentPage === 1"
                  @click="handleFirstPage">
                  首页
                </el-button>

                <!-- 分页组件 -->
                <el-pagination
                  layout="prev, pager, next"
                  :total="totalNum"
                  :page-size="pageSize1"
                  :current-page="currentPage"
                  background
                  @current-change="pageChange"
                />

                <!-- 末页按钮 -->
                <el-button 
                  class="pagination-btn first-last"
                  :disabled="currentPage >= totalPage"
                  @click="handleLastPage">
                  末页
                </el-button>
              </div>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
   

    <div class="mainbody" v-else-if="cengji == 2">
      <div class="mainbody menus" v-scroll-animate="'slide-itemgk'">
          <a href="/home"><i class="el-icon-s-home"></i></a> / <a @click="gocengji0">党建纪检</a> / {{nowTab}}  
          <span class="fontsizeCssy">字体 【 <em @click="fontsize='big'">大</em> <em @click="fontsize='default'">中</em> <em @click="fontsize='small'">小</em> 】</span>

        </div>
       <div class="articleDetailDiv" >
            <h1 v-scroll-animate="'fly-in-bottomgy'" class="fontSizeTitle">{{ nowObj.title }}</h1>
            <p v-scroll-animate="'fly-in-bottomgy'" class="fontcssxy0 fontSizeTtme">发布时间：{{ nowObj.createDate.substring(0,16) }}   <span v-if="!!nowObj.copyfrom" style="padding-left: 10px;padding-right:10px;">    来源：{{ nowObj.copyfrom }}</span>   点击量：{{ nowObj.hits }}</p>
            <div v-scroll-animate="'fly-in-bottomgy'" :class="this.fontsize=='big'?'contentcss0 contentcss0big':this.fontsize=='small'?'contentcss0 contentcss0small':'contentcss0'"  v-blank-link v-html="nowObj.content"></div>
            <!-- 新增上下篇导航 -->
    <div class="detail-pagination" v-if="!lunbostr">
  <div class="pagination-bg">
    <div class="prev-article">
      <template v-if="prevArticle">
        <span class="pagination-label">上一篇：</span>
        <a @click="gocengji1(prevArticle)" class="article-title">{{ prevArticle.title }}</a>
      </template>
      <template v-else>
        <span class="pagination-label">上一篇：</span>
        <span class="no-article">没有了</span>
      </template>
    </div>
    <div class="next-article">
      <template v-if="nextArticle">
        <span class="pagination-label">下一篇：</span>
        <a @click="gocengji1(nextArticle)" class="article-title">{{ nextArticle.title }}</a>
      </template>
      <template v-else>
        <span class="pagination-label">下一篇：</span>
        <span class="no-article">没有了</span>
      </template>
    </div>
  </div>
</div>
        </div>
    </div>
   
    </div>
  </div>
</template>

<script>
  import API from '@/api/index'
import NewsList from '@/components/NewsList'


export default {
  components: {
    NewsList
  },
  data() {
    return {
      visibleStr:false,
      fontsize:'default',
      urlBase: process.env.VUE_APP_BASE_API,
      lunbostr:false,

      activeindex0:0, //一级页面右侧tab框头部切换
      activeIndex: 0,
      gaikuangDetail:{},
      imgArr:[],
      listArr:[],
      listNow:[],
      cengji:0,
      rightList0:[],
      rightList:[],
      itemNow:{},
      activeIndex:0,
      nowTab:null,
      nowObj:{},
      currentPage:1,
      totalNum:0,
      pageSize:10,
      pageSize1:9,
       
    }
  },
  props: {
    // procardList: {
    //   type: Array,
    //   default: [],
    // },
  },
  mounted() {
     
      if(this.$route.query.cengji){
         this.cengji=this.$route.query.cengji
      }

       if(this.$route.query.typeObj){
         this.activeIndex=this.$route.query.typeObj
      }

     
     this.getRotationFn()    // 获取党建一级页面左侧轮播图
    this.getCategoryByIdFn() //获取党建一级页面右侧数据
   
   },
   computed: {
    totalPage() {
    return Math.ceil(this.totalNum / this.pageSize); // 确保使用组件内pageSize
     
  },
  pageRange() {
    return Array.from({length: this.totalPage}, (_, i) => i + 1)
  },
  prevArticle() {
      const index = this.rightList.findIndex(item => item.id === this.nowObj.id);
      return index > 0 ? this.rightList[index - 1] : null;
    },
    nextArticle() {
      const index = this.rightList.findIndex(item => item.id === this.nowObj.id);
      return index < this.rightList.length - 1 ? this.rightList[index + 1] : null;
    }
  },
  methods: {

    getPlainText(htmlString) {
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = htmlString
      return tempDiv.textContent || tempDiv.innerText || ''
    },

    // 获取党建一级页面左侧轮播图
    async getRotationFn() {
      try {
        let paramsObj={
         catId:'080c7fe1daff40cba3de798be101a627'
      }
        const res = await API.dqjjLunbo(paramsObj)
         this.imgArr=res.data.articleLinkList

        } catch (error) {
        }
      },
    changeIndex(index) {
      this.activeIndex = index
     
    },

     // 获取党建一级页面右侧
      async getCategoryByIdFn() {
      try {
        let objParams={
          catId:18,
          pageNum:1,
          pageSize:10
        }
        const res = await API.getCategoryById(objParams)
          this.listArr=res.data.titleList
          this.itemNow=res.data.titleList[0]
          this.nowTab=res.data.titleList[0].name
          this.rightList0=res.data.titleList[0].articleList

            if(this.$route.query.typeObj){
           this.itemNow=res.data.titleList[this.$route.query.typeObj]
           this.nowTab=res.data.titleList[this.$route.query.typeObj].name
           this.rightList0=res.data.titleList[this.$route.query.typeObj].articleList
          }

          // this.rightList0[0].articleData['content1']=this.getPlainText(this.rightList0[0].articleData.content)
          // this.rightList0[1].articleData['content1']=this.getPlainText(this.rightList0[1].articleData.content)
          
          // this.rightList=res.data.titleList[0].articleList
          this.getlist2()
          

        } catch (error) {
        }
      },

       // 二级列表页面 获取数据方法
       async getlist2() {
  try {
    const params = {
      catId: this.itemNow.id,
      pageNum: this.currentPage,
      pageSize: 9 // 确保传参
    };
    const res = await API.getArticleById(params);
    this.rightList = res.data.artList;
    this.totalNum = res.data.totalNum;
    this.totalPage=res.data.totalPage
    console.log("总页数",this.totalPage)
  } catch (error) {
    console.error('数据加载失败', error);
    this.$message.error('数据加载失败');
  }
},
pageChange(page) {
  this.currentPage = page;
  this.getlist2();
},
handleFirstPage() {
      if (this.currentPage !== 1) {
        this.pageChange(1)
      }
    },
    handleLastPage() {
      const last = this.totalPage
      if (this.currentPage !== last) {
        this.pageChange(last)
      }
    },    


    gocengji0(){
      this.cengji--
      //  const targetRoute = this.$router.resolve({
      //        path: '/nsc'
      //     });
      //      window.open(targetRoute.href, '_blank');
    },
    goMore(){
      this.cengji++
      this.getlist2()
    },
     // 详情页
     async gocengji1(obj,lunboObj) {
      

      this.cengji=2
       const targetRoute = this.$router.resolve({
             path: '/NscDetail',
             query: {                     
               artId: !!lunboObj?obj.articleId:obj.id,
             lunboObj:lunboObj,
             typeObj:this.activeIndex
           }
        });
        window.open(targetRoute.href, '_blank');
         
        // window.location.reload();
      
    },
    changeTab(obj){
      this.activeindex0=obj
      this.activeIndex=obj
      this.nowTab= this.listArr[obj].name
      this.itemNow=this.listArr[obj]
     
      // if(this.listArr[obj].articleList.length>7){
      //   this.rightList0=this.listArr[obj].articleList.slice(0,7)
      // }else{
      //   this.rightList0=this.listArr[obj].articleList
      // }
      
      this.getlist2()

    },
    
    changeTab1(obj){ 
     debugger
      this.activeindex0=obj
      this.activeIndex=obj
      this.nowTab= this.listArr[obj].name
      this.itemNow=this.listArr[obj]
      
     if( this.itemNow.id != '7' && this.cengji==0){
      this.visibleStr=true
     }else{
      this.visibleStr=false
     }

      if(obj == 0){
        if(this.listArr[obj].articleList.length>7){
          this.rightList0=this.listArr[obj].articleList
        }else{
          this.rightList0=this.listArr[obj].articleList
        }
      }else{
        this.getlistOther()
       
      }
      
    },
       // 1级页面其他tab框获取数据方法 获取数据方法
       async getlistOther() {
       
       try {
         const params = {
           catId: this.itemNow.id,
           pageNum: this.currentPage,
           pageSize: this.pageSize // 确保传参
         };
         debugger
         const res = await API.getArticleById(params);
        
           this.$nextTick(()=>{
               if(res.data.artList.length>7){
                 this.rightList0=res.data.artList
               }else{
                 this.rightList0=res.data.artList
               }
           })

            

       } catch (error) {
         console.error('数据加载失败', error);
         this.$message.error('数据加载失败');
       }
     },
      
  },
}
</script>

<style lang="scss" scoped>
.detail-pagination {
    margin: 2rem auto 0;
    padding: 1rem 0;
    border-top: 1px solid #eee;
  
    .pagination-bg {
      background: #f8f8f8;
      padding: 1.2rem;
      border-radius: 4px;
    }
  
    .prev-article, .next-article {
      line-height: 1.8;
      font-size: 0.95rem;
      
      + .next-article {
        margin-top: 0.8rem;
      }
    }
  
    .pagination-label {
      color: #999;
      margin-right: 0.5rem;
    }
  
    .article-title {
      color: #333;
      cursor: pointer;
      transition: color 0.3s;
  
      &:hover {
        color: #015293;
        text-decoration: underline;
      }
    }
  
    .no-article {
      color: #999;
    }
  }
.pagination-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 2rem 0;

  .page-nav {
   
    padding: 10px 24px; 
    min-width: 88px;    
    border: 1px solid #ddd;
    border-radius: 22px; 
    color: #666;
    background: transparent;
    transition: all 0.2s ease;
    height: 44px;     
    line-height: 22px;  
    
    &:hover:not(:disabled) {
      background: #f5f5f5;
      border-color: #ccc;
    }
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .page-number {
    
    width: 44px;
    height: 44px;
    border: 1px solid #ddd;
    border-radius: 50%;
    background: transparent;
    color: #666;
    transition: all 0.2s ease;
    flex-shrink: 0;    

    &.active {
      background: #015293;
      border-color: #015293;
      color: white;
    }
    
    &:hover:not(.active) {
      background: #f5f5f5;
      border-color: #ccc;
    }
  }

  button {
    cursor: pointer;
    font-size: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    outline: none;
    font-family: system-ui, -apple-system; 
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
.procard_wrapCss0{
  width: 100vw; 
  margin: 0 auto;
  margin-top:2rem;
}
.procard_wrap { 
  width: 90%;
  margin:0 auto;
  // background: #d33520;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  // padding-bottom: 8rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.02) inset;
  @media screen and (max-width: 768px) {
    width: 95%;
    background: #f7f7f7;
    }
  .procard_btn {
    width: 100%;
    display: flex;
    .mobileGkmenu{
      display:none;
    }
    .procard_item {
      flex: 1;
      height: 80px;
      background: #f5f5f5;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      position: relative;
      cursor: pointer;
      @media screen and (max-width: 768px) {
        display:none;
        height: 60px;
        text-align: center;
        font-size: 12px;
      }
    }
    .active {
      color: #fff;
      background: #015293;
      font-weight: bold;
      &::before {
        // content: '▲';
        position: absolute;
        color: #015293;
        font-size: 40px;
        transform: rotateX(180deg);
        bottom: -27px;
      }
    }
    @media screen and (max-width: 768px) {
      
        .mobileGkmenu{
          display:block;
          width:100%;
          height:10rem;
          .mobileGkdiv{
            background:#e5e5e5;
            margin:0.25rem;
            line-height:2rem;
            text-align:center;
          }
          .active {
            font-weight: bold;
            &::before {
              content: '';
            }
          }
        }
    }
  }
  .procard_content {
    width: 100%;
    display: flex;
    padding: 30px 0;
    // justify-content: center;
    @media screen and (max-width: 768px) {
      flex-direction: column;
      width: 100%;
    }
    .content_left {
      width: 52%;
     margin-top:1rem;
      // height:650px;
      // border:1px solid #2091d3;
       @media screen and (max-width: 768px) {
        width: 100%;
      }
      img{
        width: 100%;
      }
    }
    .content_right {

      width: 48%;
      padding:0 3em;
      padding-right:0;
      // display: flex;
      // background: #b3d8ee;
      @media screen and (max-width: 768px) {
        width: 100%;
        text-align: center;
 
        padding-right:3em;

      }
      text-align: left;
      .right_tit{
        margin-top:1rem;
        width: 100%;
        // margin-left: 5%;
        position: relative;
        border-bottom: 1px solid red;
        @media screen and (max-width: 768px) {
          // margin-top:12rem;
          width: 90%;
          margin-left: 5%;
        }
        span{
          font-size: 1rem;
          color: #676565;
          font-weight: bold;
          display: inline-block;
          text-align: center;
          cursor: pointer;
          width: 6rem;
          height: 2rem;
          line-height: 2rem;
        }
        span.active{
          color: #ffffff;
          font-weight: bold;
          background:#e83428;
        }
        a.moreA{
         float: right;
          color: #999999;
        }
      }
      .right_txt{
        // border: 1px solid #000;
        // border-top: none;
        // padding-left: 1rem;
        // padding-right: 1rem;

        // text-indent: 2em;
        font-size: 1.2rem;
        line-height:2rem;
        padding-top: 0.8rem;
        @media screen and (max-width: 768px) {
          line-height:2rem;  
          text-align: left;
        }
        
      }
    }
  }
}
.procard_wrap1 {
  background:url('../../assets/w/img3/dangjian1/dangjian-bg.png');
  // background-size:100% 100%;
  background-size: cover;
  min-height: 80vh;
}
.el-carousel__item{
  width: 100%;
  overflow: hidden;
  text-align: center;
 
  @media (max-width: 768px) {
    img{
      height: 92% !important;
    width: 100% !important;
    }
  }
} 
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
    margin-top:-2rem;
    color:#2091d3
  }

  .el-carousel__item:nth-child(2n) {
    //  background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    //  background-color: #d3dce6;
  }
  .divtxt0{
    display: flex;
    padding:1rem 0;
    width:100%;
    padding-left: 5%;
    @media (max-width: 768px) {
       display: none;
    }
    
    div.timeDiv{
      flex: 10%;
      // margin-left: 5%;
      text-indent:0;
      padding:0.5rem;
      background: #ccba85;
      border-radius: 10%;
      color: #ffffff;
      display: flexbox;
      text-align: center;
      // height: 4.5rem;

      span{
        
        font-weight: bold;
        font-size: 1.2rem;
      }
    
     
    }
    div.titleDiv{
      flex: 85%;
      padding-left: 40px;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      /* 限制显示行数 */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      .titleSpan{
        color:#333333;
        font-weight:bold;
        padding-top: 0rem;
        font-size: 1.1rem;
        display: block;
        width: 100%;
        height:1.5rem;
        line-height: 1.5rem;
        white-space: nowrap;      /* 禁止换行 */
        overflow: hidden;         /* 隐藏超出内容 */
        text-overflow: ellipsis;  /* 显示省略号 */
        width: 100%;             /* 需要指定宽度 */
        a{
          color: #333333;
        }
        a:hover{
          color: #015293;
        }
      }
      .contentSpan{
        // display: block;
        all: unset;
        // display: block;
        width: 97%;
        // background: #d33520;
        color:#5b5959;
        font-size: 1rem;
        cursor: pointer;
        line-height: 1.5rem;
        text-indent: 2rem !important;
        display: -webkit-box;
        margin-top: 0.5rem;
        -webkit-line-clamp: 2;      /* 限制显示行数 */
        -webkit-box-orient: vertical; /* 垂直排列 */
        overflow: hidden;          /* 超出部分隐藏 */
        text-overflow: ellipsis;   /* 超出部分显示省略号 */
      }
    }
  }
  div.divtxt00{
    display: none;
    @media (max-width: 768px) {
       display: block;
       margin-top:1rem;
       .titleSpan{
        color:#333333;
        font-weight: bold;
        font-size: 1rem;
      }
      div.timeDiv{
        background: #ccba85;
        color: #ffffff;
        padding:0.5rem 0;
        margin:0.8rem 0;
        @media (max-width: 768px) {
        display: none;
      
      }
       
      }
      div.titleDiv{
        display: -webkit-box;
        -webkit-line-clamp: 4;
        /* 限制显示行数 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
       }
    }
    margin-bottom: 2rem;
  }
  .divtxt1{
    // border-top: 1px solid #d1d0d0;
   
  }
  .divtxt{
    // background: #2091d3;
    width: 100%;
    display: flex;
    font-size: 1rem !important;
    // padding:0.8rem 0;
    height: 2.8rem;
    line-height: 2.8rem;
    padding-bottom: 0;
    color: #888888;
    cursor: pointer;
    @media (max-width: 768px) {
      width: 100%;
      line-height: 1.5rem;
      margin-bottom: 0.6rem;
      font-size: 1rem;
    }
    .titleSpan{
      flex: 80%;
      // height:1.5rem;
      font-weight: 300;
      white-space: nowrap;      /* 禁止换行 */
      overflow: hidden;         /* 隐藏超出内容 */
      text-overflow: ellipsis;  /* 显示省略号 */
      width: 100%; 
      a{
        color:#333333;
        font-weight: 300;
      }           
      a:hover{
        color:#015293;
        font-weight: 500;
      }
      @media screen and (max-width: 768px) {
        flex: 65%;
      }
    }
    .timeSpan{
      flex: 20%;
      text-align: right;
      color:#333333;
      font-size: 0.9rem;
      font-weight: 100;
      @media screen and (max-width: 768px) {
        flex: 25%;
      }
    }

}

.mainbody0{
  width: 100%;
  margin:0 auto;
  @media (max-width: 768px) {
      width: 100%;
  }
}
.mainbody{
  width: 100%;
 }
//  .menus{
//   padding:1rem;
//   padding-left: 0;
//   font-size:1rem;
//  }
 .Lmenu{
  margin-top:1rem;
  // padding:1rem;
  margin-bottom:0.5rem;
  font-size:1rem;
  background:#eee;
  text-align:center;
  a{
    color:#666;
  }
 }
 .active{
    // background:#2091d3;
    a{
      color:#ffffff;
      // background: linear-gradient(to right, rgba(149, 216, 243, 0.5), #2091d3);
      // background: #015293;
      background: #e83428;
      // transition: background 0.5s ease;
   }
  }
  .imgLeft{
   
    @media screen and (max-width: 768px) {
      // height:35vh;
      
    }
    
  }
 .Rcontent{
  display:flexbox;
  padding:1rem;
  padding-top:0;
  background:#ffffff;
  margin-left:3.5rem;
  @media screen and (max-width: 768px) {
    margin-left:0;
  }
    ul{
      li{
        list-style:none;
        // padding:1rem;
        line-height:1rem;
        border-bottom:1px solid #e5e5e5;
        display:flex;
        .Rtime{
          padding:1rem; 
          background:#e5e5e5;
          border-radius: 0.5rem;
          padding-bottom: 0.8rem;
          a{ 
            display: block;
            width:100%;
            text-align: center;
            font-size:1rem;
            font-weight:bold;
            color:#dab773;
            padding-top:0.5rem;
           
          }
          a.acss0{
            font-size: 1.2rem;
          }
        }
        .Rtitle{
          flex:80%;
          // padding:1.3rem;
          line-height: 3rem;
          padding-top:0.5rem;
          font-size:1rem;
          @media (max-width: 768px) {
            padding-top:1.5rem;
            line-height: 2rem;
            padding-bottom:1.5rem;
          }
          a{
            color:#333;
            
          }
          a:hover{
            color:#015293;
          }
          p.pcss0{
            font-size: 0.8rem;
            width: 65vw !important;
            height: 4rem;
            background: #015293;
            width: 100%;
            height: 4rem;
            background: #015293;
            display: -webkit-box;
            -webkit-line-clamp: 2;     /* 限制显示行数 */
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            span{
              display: -webkit-box;
              -webkit-line-clamp: 2;     /* 限制显示行数 */
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
      li.lastLi{
        border-bottom:none;
      }
    }
 }
 .articleDetailDiv{
  width: 90vw;
    margin: 0 auto;
    padding:0 70px 50px;
    border:  1px solid #e5e5e5;
    margin: 0 auto;
    margin-bottom: 1rem;
    h1{
      width: 80%;
      margin:0 auto;
      margin-bottom: 1rem;
      border-bottom: 1px solid #999999;
      text-align: center;
      padding:1rem 0;
    }
    p{
      text-align: center;
    }
    div.contentcss0{
      margin: 0 auto;
      margin-top: 1rem;
     
      @media screen and (max-width:768px) {
        *{
          font-size: 0.5rem !important;
        }
     }
       
    }
      // 重置字体样式001
      div.contentcss0 :not(.keep-style) {
      // width: 90%;
      margin: 0 auto;
      // margin-top: 1rem;
      font-size:1rem !important;
      line-height: 2em !important;
      text-indent:2rem !important;
      // text-align: left !important;
      // text-align: justify !important;
      color: #333333 !important;
      @media (min-width: 0px) and (max-width: 991px) {
      span img{
          margin-left: -28px!important;
        }
      }
    }
  }

  // 重置图片样式 002
  div.contentcss0  img {
    border: var(--img-border, none) !important;
    width: var(--img-width, auto) !important;
    height: var(--img-height, auto) !important;
  }

  /* 使用深度选择器（Vue 2/3 兼容写法） */
  .contentcss0 >>> img,.contentcss0 ::v-deep img,.contentcss0 :deep(img) {
    border: none !important; /* 移除边框 */
    padding: 0 !important;
    // margin: 0!important;
    box-shadow: none !important;
    display: block;
    margin:0 auto !important;
    width: 60% !important;
  }
  .contentcss0 >>> table,.contentcss0 ::v-deep table,.contentcss0 :deep(table) {
    
    margin:0 auto !important;
    width: 80% !important;
  }
  
  .change_page{
    width: 90%;
    margin: 0 auto;
    margin-top: 1rem;
  }
 .custom-indicator{
  color:#ffffff;
  // padding-top: 10px;
  font-size: 0.9rem;
 }
 ::v-deep .el-carousel__item .custom-indicator{
  // background: #da4116 !important;
 }
 
::v-deep .pcss0{
            font-size: 0.8rem;
            width: 100%;
            height: 4rem;
            background: #015293;
            overflow: hidden;
            white-space: nowrap;      /* 禁止换行 */
            overflow: hidden;         /* 隐藏超出内容 */
            text-overflow: ellipsis;  /* 显示省略号 */
           
          }
.explainsTxt{
  display: inline-block;
  white-space: nowrap;      /* 禁止换行 */
  overflow: hidden;         /* 超出部分隐藏 */
  text-overflow: ellipsis;  /* 超出部分显示省略号 */
  width: 100%;             /* 或者指定一个固定宽度 */
}

.articleDetailDiv {
    div.contentcss0big :not(.keep-style) {
        font-size: 1.1rem !important;
    }

    div.contentcss0small :not(.keep-style) {
        font-size: 0.9rem !important;
    }
}

 

</style>